import './styles.scss';
import React, { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: JSX.Element;
  small?: boolean;
};

const IconButton = (props: Props) => {
  const { icon, small, ...domProps } = props;

  const className = [
    'icon_button__base',
    small ? 'icon_button__small' : '',
    domProps.className ?? ''
  ].join(' ');

  return (
    <button {...domProps} className={className}>
      {icon}
    </button>
  );
};

export default IconButton;
